import { registerSW } from 'virtual:pwa-register';

const setupAutoUpdates = () => {
    const intervalMS = 60 * 60 * 1000; // Check every hour

    const updateSW = registerSW({
        onNeedRefresh() {
            // Automatic update without prompting
            updateSW();
            console.log('New version installed, reloading...');
            setTimeout(() => {
                window.location.reload();
            }, 1000); // Small delay to ensure service worker is active
        },
        onOfflineReady() {
            console.log('App ready to work offline');
        },
        // Automatically check for updates periodically
        registerOptions: {
            immediate: true
        }
    });

    // Optional: Force check for updates periodically
    setInterval(() => {
        console.log('Checking for updates...');
        updateSW(true); // Force update check
    }, intervalMS);
};

export default setupAutoUpdates;
